<template>
    <v-badge left class="pa-0" overlap color="error">
        <template slot="badge" v-if="newAlerts > 0">
            <span>{{ newAlerts }}</span>
        </template>
        <v-menu
            v-model="closeMenu"
            offset-y
            left
            origin="right top"
            z-index="99"
            content-class="notification-dropdown"
            transition="slide-y-transition"
            nudge-top="-10"
            :close-on-content-click="false"
        >
            <!-- <v-btn @mouseup.left="$emit('closeProfile')" class="pa-0 mr-15" dark icon slot="activator">

                <notification-bell iconColor="white" :count="unread_notifications_count" :animated="true"></notification-bell>
            </v-btn> -->
            <div class="dropdown-content">
                <app-section-loader :status="modal_loader"></app-section-loader>
                <v-btn @mouseup.left="goToNotifications()" class="my-0" depressed color="primary" text-color="white" block>{{
                    $t("lang.view_all_notifications")
                }}</v-btn>
                <vue-perfect-scrollbar class="scroll-area" :style="$bp.xs ? null : 'max-height: calc(100vh - 150px)'">
                    <v-list two-line class="dropdown-list">
                        <template v-for="(notification, index) in inAppNotifications">
                            <bc-tooltip left max-width="300" :key="index" v-if="index < 5">
                                <template slot="activator">
                                    <div @mouseover="hovered(index, true)" @mouseout="hovered(index, false)">
                                        <v-divider v-if="index > 0" class="ma-0 grey lighten-1"></v-divider>
                                        <v-list-tile
                                            avatar
                                            v-ripple
                                            class="clickable text-xs-center headline"
                                            :class="notification.read_flag == '1' ? null : 'blue-grey lighten-4'"
                                        >
                                            <v-list-tile-action style="min-width: 40px">
                                                <v-icon v-if="notification.icon" :color="notification.icon_class">{{ notification.icon }}</v-icon>
                                            </v-list-tile-action>
                                            <v-list-tile-content>
                                                <v-list-tile-title v-html="notification.subject" class="fw-bold"></v-list-tile-title>
                                                <v-list-tile-sub-title v-html="notification.message"></v-list-tile-sub-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action
                                                style="min-width: 40px"
                                                v-show="$bp.xs || (hoverID !== null && index == hoverID)"
                                                @click="readNotification(notification, notification.notification_id)"
                                            >
                                                <v-btn icon :color="notification.read_flag == '1' ? 'success' : 'grey lighten-2'"><v-icon>check</v-icon></v-btn>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </div>
                                </template>
                                {{ notification.message }}
                            </bc-tooltip>
                        </template>
                    </v-list>
                </vue-perfect-scrollbar>
                <div
                    v-if="!inAppNotifications || inAppNotifications.length == 0"
                    class="grey--text"
                    style="width: 100%; height: calc(60vh - 250px); display: flex; justify-content: center; align-items: center"
                >
                    {{ $t("lang.no_notifications") }}
                </div>
                <v-btn @mouseup.left="getInAppNotifications(true)" class="my-0" depressed color="primary" text-color="white" block
                    ><v-icon>refresh</v-icon></v-btn
                >
            </div>
        </v-menu>
        <v-dialog v-model="notifPopupDialog" max-width="500" persistent scrollable>
            <v-card class="h-100" dark>
                <v-card-title class="pb-1 no-color">
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="notifPopupDialog"
                        :dialog-status="notifPopupDialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text class="py-1">
                    <v-carousel :cycle="false" class="elevation-0" hide-controls :hide-delimiters="popupNotifs.length == 1">
                        <v-carousel-item v-for="(notification, i) in popupNotifs" :key="i">
                            <v-container fluid grid-list-xl fill-height class="pa-0">
                                <v-layout row wrap :style="popupNotifs.length == 1 ? null : 'padding-bottom:50px'">
                                    <v-flex xs12>
                                        <v-icon v-if="notification.icon" x-large :color="notification.icon_class">{{ notification.icon }}</v-icon>
                                        <v-flex class="text-center display-1 my-1">{{ notification.subject }}</v-flex>
                                        <v-flex class="text-center headline my-1">{{ notification.message }}</v-flex>
                                    </v-flex>
                                    <v-flex xs12 align-self-end pb-0>
                                        <v-checkbox
                                            v-model="notification_id[i]"
                                            :value="notification.notification_id"
                                            @change="readNotification(notification, notification.notification_id, notification_id[i])"
                                        >
                                            <template slot="label">
                                                {{ $t("lang.do_not_show") }}
                                            </template>
                                        </v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-carousel-item>
                    </v-carousel>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-badge>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import NotificationBell from "vue-notification-bell";
import AppConfig from "Constants/AppConfig";

export default {
    components: {
        NotificationBell,
    },
    data() {
        return {
            hoverID: null,
            closeMenu: false,
            timer: "",
            notifPopupDialog: false,
            popupNotifs: [],
            notification_id: [],
            unread_notifications_count: 0,
        };
    },
    mounted: function () {
        // DISABLED FOR NOW
        this.getInAppNotifications();
        // this.timer = setInterval(this.getInAppNotifications, 10 * 60 * 1000) // 10 minutes

        // this.$root.$on("getInAppNotifications", (data) => {
        //     this.getInAppNotifications();
        // });
        this.updateTitle();
    },
    computed: {
        ...mapGetters(["getLoginFlag", "newAlerts", "inAppNotifications", "modal_loader"]),
    },
    watch: {
        newAlerts() {
            this.updateTitle();
        },
    },
    methods: {
        ...mapActions(["saveNotification"]),
        updateTitle() {
            if (this.newAlerts > 0) {
                document.title = `(${this.newAlerts}) ` + AppConfig.brand;
            } else {
                document.title = AppConfig.brand;
            }
        },
        goToNotifications() {
            this.closeMenu = false;
            //this.$router.push({ path: `/people/profile/${this.currUserField("people_id")}` });
            this.$router.push({ name: "notifications", params: { id: this.currUserField("people_id") } });
        },
        getInAppNotifications(status = false) {
            let body = { page_size: 5 };
            if (status) this.$store.commit("toggleModalLoader", true);
            this.component_loader = true;
            this.$store
                .dispatch("fetchInAppNotifications", {
                    url: "notifications/",
                    method: "get",
                    body: body,
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.$store.commit("setInAppNotifications", data.notifications);
                        this.unread_notifications_count = data.page.new_notifications;
                    }
                })
                .finally(() => {
                    if (status) this.$store.commit("toggleModalLoader", false);
                });
            // this.$store
            //     .dispatch("fetchMe", {
            //         url: "me/notifications",
            //         method: "get",
            //         stateProperty: "notifications",
            //         commit: true,
            //     })
            //     .then((data) => {
            //         if (typeof data !== "undefined") {
            //             this.$store.commit(
            //                 "setNotifications",
            //                 data.notifications.filter((notification) => {
            //                     return notification.read_flag == 0;
            //                 }).length
            //             );
            //             // if user has just logged in, check for pop up notifications and display them
            //             // also manage language
            //             if (this.getLoginFlag) {
            //                 this.popupNotifs = this.notifications.filter((notif) => notif.modal == "1" && notif.read_flag == "0");
            //                 if (this.popupNotifs.length > 0) {
            //                     this.notifPopupDialog = true;
            //                 }

            //                 this.$store.commit("resetLoginFlag");
            //             }
            //         } else {
            //             clearInterval(this.timer);
            //         }
            //         if (status) this.$store.commit("toggleModalLoader", false);
            //     });
        },
        readNotification(notification, id) {
            let body = { notification_id: id, read_flag: notification.read_flag == "1" ? "0" : "1" };
            this.saveNotification({
                body: body,
            }).then((data) => {
                this.$store.commit("setInAppNotifications", data.notifications);
                this.unread_notifications_count = data.page.new_notifications;
            });
            // if (notification.read_flag == "1") {
            //     notification.read_flag = "0";
            //     this.$store.dispatch("fetchMe", {
            //         url: "me/notifications/" + id + "/unread",
            //         method: "patch",
            //     });
            //     this.$store.commit("updateNewAlertsHandler", this.newAlerts + 1);
            // } else {
            //     notification.read_flag = "1";
            //     this.$store.dispatch("fetchMe", {
            //         url: "me/notifications/" + id + "/read",
            //         method: "patch",
            //     });
            //     this.$store.commit("updateNewAlertsHandler", this.newAlerts - 1);
            // }
        },
        hovered(index, status) {
            status ? (this.hoverID = index) : (this.hoverID = null);
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>
<style lang="css">
.notification {
    background-color: transparent;
}
</style>
